import dlv from 'dlv';
import flat from 'flat';
import { FieldValues } from 'react-hook-form';
import {
	DateFieldConfiguration,
	EmailFieldConfiguration,
	NumberFieldConfiguration,
	SelectFieldConfiguration,
	StringFieldConfiguration,
} from '../../../api/ConfigApi';
import {
	PolicyholderUpdateRequest,
	PolicyholderUpdateValues,
} from '../../../types/policyholder';
import { FIELD_TYPES } from '../data/constants';
import { DirtyFields, FlatDirtyFields, FormBuilder, FormShape } from '../types';
import { dateConversion, flattenObjectByName } from '../utils';

const policyholderUpdateBuilder = (
	dirtyFields: { [key: string]: DirtyFields },
	formValues: FieldValues,
	fields: FormShape<FormBuilder>,
	primaryFormName: string,
	locator: string,
	version: string,
	timezone: string,
) => {
	const updateRequest: PolicyholderUpdateRequest = {
		locator,
		version: parseInt(version, 10),
		completed: true,
		values: {},
	};

	const flatDirtyFields = flat(dirtyFields, { safe: true }) as FlatDirtyFields;
	const flatFields = flattenObjectByName(
		fields[primaryFormName].fields,
		primaryFormName,
	);

	Object.keys(flatDirtyFields).forEach((fieldName) => {
		let currValue = dlv(formValues, fieldName);
		const currField = flatFields[fieldName] as
			| EmailFieldConfiguration
			| DateFieldConfiguration
			| NumberFieldConfiguration
			| SelectFieldConfiguration
			| StringFieldConfiguration;

		if (currField.type === FIELD_TYPES.date) {
			const dateObject = dateConversion.dateFormStringToDayJs(
				currValue as string,
				(currField as DateFieldConfiguration).precision,
			);
			const parsedDate = dateConversion.dayJsToLocalizedBackendFormattedString(
				dateObject,
				(currField as DateFieldConfiguration).precision,
				timezone,
			);
			currValue = parsedDate || '';
		}

		const newValue = {
			type: currField.ontologyType,
			value: currValue === '' ? [] : [currValue],
		} as PolicyholderUpdateValues;
		updateRequest.values[currField.name] = newValue;
	});

	return updateRequest;
};

export default policyholderUpdateBuilder;
